import { memo } from 'react';
import PropTypes from 'prop-types';
import { Header } from '@components/navigation/Header';
import { cn } from '@helpers/styleUtils';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { UserLists } from '@layouts/admin/UserLists';
import { RoleLists } from '@layouts/admin/RoleLists';
import { EditWidgets } from '@layouts/admin/EditWidgets';
import { FaUsers, FaUserTie } from 'react-icons/fa';
import AddWidget from '@layouts/admin/AddWidget';

const AdminContainer = () => {
    const location = useLocation();
    const { role_id } = useParams();
    const navigate = useNavigate();

    const renderLayout = () => {
        switch (location.pathname) {
            case '/admin/users':
                return <UserLists />;
            case '/admin/roles':
                return <RoleLists />;
            case `/admin/role/${role_id}/edit_widgets`:
                return <EditWidgets />;
            case `/admin/add_widget`:
                return <AddWidget />;
            default:
                return (
                    <div className="grid grid-cols-2 gap-4">
                        <div
                            className="group bg-white hover:bg-primary-blue shadow-card h-56 w-full flex items-center justify-center flex-col gap-2 rounded-[10px] hover:text-white cursor-pointer"
                            onClick={() => navigate('/admin/roles')}
                        >
                            <FaUserTie className=" text-6xl" />
                            <p className="group-hover:text-white text-2xl font-bold">Role List</p>
                        </div>
                        <div
                            className="group bg-white hover:bg-primary-blue shadow-card h-56 w-full flex items-center justify-center flex-col gap-2 rounded-[10px] hover:text-white cursor-pointer"
                            onClick={() => navigate('/admin/users')}
                        >
                            <FaUsers className=" text-6xl" />
                            <p className="group-hover:text-white text-2xl font-bold">Users List</p>
                        </div>
                    </div>
                );
        }
    };

    return (
        <div className="container-wrapper relative mb-12">
            <Header />
            <main
                className={cn(
                    'page-wrapper h-full px-4 md:px-6 lg:px-12 py-8 flex lg:flex-row flex-col items-start gap-8 relative box-border transition-all duration-300',
                )}
            >
                <div className={cn(' w-full box-border')}>
                    <div className="w-full flex items-center justify-between mb-4">
                        <p className="text-2xl font-extrabold">
                            {location.pathname === `/admin/role/${role_id}/edit_widgets`
                                ? 'Edit Widget'
                                : 'Admin Panel'}
                        </p>
                    </div>
                    {renderLayout()}
                </div>
            </main>
        </div>
    );
};

AdminContainer.propTypes = {
    children: PropTypes.node,
};

export default memo(AdminContainer);
